import React from 'react';
import moment from 'moment';
import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';
import { DateFormats } from 'constants/common';
import makeStyles from '@mui/styles/makeStyles';
import { Dashboard, Delete, Edit } from '@mui/icons-material';
import { Box, IconButton, Paper, Stack, Tooltip, Typography } from '@mui/material';

import { useExternalDashboards } from '../../api';
import { AdminDashboardOption } from '../../types';
import { OPTION_LIST_ICON_MAPPER } from '../../constants';

interface Props {
  dashboardOption: AdminDashboardOption;
}

export const AdminDashboardListItem = ({ dashboardOption }: Props) => {
  const classes = useStyles();

  const { handleDelete, isDeleting } = useExternalDashboards();
  const { handleOpen } = useModal(ModalsKeys.ExternalDashboardDialog);

  return (
    <Paper className={classes.container}>
      <Box className="card">
        <Box className="header">
          {dashboardOption.icon ? OPTION_LIST_ICON_MAPPER[dashboardOption.icon] : <Dashboard color="primary" />}

          <Stack sx={{ flex: 1 }}>
            <Typography color="textSecondary" variant="h6" component="span">
              {dashboardOption.name}
            </Typography>

            <Stack direction="row" alignItems="center" gap="1rem">
              <Typography color="textSecondary" component="span">
                Created at: {moment(dashboardOption.createdDateTime).format(DateFormats.DateTimeMedium24Hour)}
              </Typography>

              <Typography color="textSecondary" component="span">
                Updated at:{' '}
                {dashboardOption.updatedDateTime
                  ? moment(dashboardOption.updatedDateTime).format(DateFormats.DateTimeMedium24Hour)
                  : 'No updated'}
              </Typography>
            </Stack>
          </Stack>

          <Stack direction="row" gap="1rem">
            <Tooltip title="Edit dashboard">
              <IconButton size="small" loading={isDeleting} onClick={() => handleOpen({ id: dashboardOption.id })}>
                <Edit color="primary" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Remove dashboard">
              <IconButton size="small" loading={isDeleting} onClick={() => handleDelete({ id: dashboardOption.id })}>
                <Delete color="error" />
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>
      </Box>
    </Paper>
  );
};

const useStyles = makeStyles({
  container: {
    padding: '0.5rem',

    '& .card': {
      gap: '0.5rem',
      display: 'flex',
      flexDirection: 'column',

      '& .header': {
        gap: '1rem',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      },
    },
  },
});
